module.exports = __webpack_public_path__ + "img/about-coin.10054d9c.png";